// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PShoppingOutlinedSvg from "@fishx/icons-svg/es/asn/PShoppingOutlined";
import FishxIcon from '../components/FishxIcon';

var PShoppingOutlined = function PShoppingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PShoppingOutlinedSvg
  }));
};

PShoppingOutlined.displayName = 'PShoppingOutlined';
export default React.forwardRef(PShoppingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PShoppingOutlined.js
// module id = 3634
// module chunks = 0